











import { Component, Prop, Vue } from "vue-property-decorator";

import { countryCodes } from "@/config/user/citizenship";
import { ICitizenship } from "@/@types/_shared/documents/citizenship";

@Component({})
export default class CitizenshipsName extends Vue {
  @Prop({ type: String, default: "" }) code!: string;

  get citizenship(): ICitizenship | null {
    const citizenship = countryCodes.find((c) => c.code2 == this.code);
    return citizenship ? citizenship : null;
  }
}
